import React,{useEffect,useState} from "react";
import {db,functions,auth} from "../../firebase/firebase.js";
import {doc,getDoc} from "firebase/firestore";
import {httpsCallable} from "firebase/functions";
import DashboardLayout from "../../views/layout/DashboardLayout";
import "../../styles/DashboardFixes.css";

export default function BusinessTierSettings() {

  const [businessId, setBusinessId] = useState("");
  const [tier, setTier] = useState("starter");
  const [loading, setLoading] = useState(true);

  const setTierFn = httpsCallable(functions, "setBusinessTier");

  useEffect(() => {
    const user = auth.currentUser;
    if (!user) return;
    loadUser(user.uid);
  }, []);

  const loadUser = async (uid) => {
    const userSnap = await getDoc(doc(db, "users", uid));
    if (!userSnap.exists()) return;

    const data = userSnap.data();
    setBusinessId(data.businessId);

    loadTier(data.businessId);
  };

  const loadTier = async (bid) => {
    const snap = await getDoc(doc(db, "businesses", bid, "subscription", "active"));
    if (snap.exists()) {
      const data = snap.data();
      setTier(data.tier || "starter");
    }
    setLoading(false);
  };

  const updateTier = async () => {
    await setTierFn({ businessId, tier });
    alert("Business tier updated!");
  };

  if (loading) {
    return (
      <DashboardLayout>
        <h2>Loading tier…</h2>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>

      <h2 className="text-2xl font-bold mb-8">Business Subscription Tier</h2>

      <div className="max-w-xl bg-[#111] p-6 rounded-xl border border-gray-800">

        <label className="block text-gray-400 mb-3">Select Tier</label>

        <select
          value={tier}
          onChange={(e) => setTier(e.target.value)}
          className="w-full p-3 bg-black border border-gray-700 rounded text-white"
        >
          <option value="starter">Starter (£0 included)</option>
          <option value="pro">Pro (£299/mo)</option>
          <option value="enterprise">Enterprise (£999/mo)</option>
        </select>

        <button
          onClick={updateTier}
          className="w-full mt-6 bg-purple-600 hover:bg-purple-700 py-3 rounded-lg text-white"
        >
          Update Tier
        </button>

      </div>

    </DashboardLayout>
  );
}
